import { IconTooltip } from 'apps/studio/components/shared/IconTooltip'

export const PanelControls = ({
  side,
  togglePanelAction,
  showPanelControls,
  controls = [],
}) => {
  return (
    <div className={`panel-controls ${side}-panel--controls`}>
      {showPanelControls &&
        controls.map(({ active, type, icon: Icon }) => (
          <button
            className={`gcds--button button--toggle is-bordered panel-control${active ? ' is-active' : ''}`}
            type="button"
            key={`${type}-panel-control`}
            onClick={() => togglePanelAction(type)}
          >
            <IconTooltip
              Icon={Icon}
              tooltipContent={type}
              position={side === 'left' ? 'right' : 'left'}
              delay={0.1}
            />
          </button>
        ))}
    </div>
  )
}
